import { getAuth } from 'firebase/auth';

export const auth = getAuth();